import React, { Fragment } from "react";
import { TApiOrderDetails } from "../../../api/endpoints/Order";
import OrderPolicy from "../../../policies/OrderPolicy";
import { User } from "../../../entities/User";
import OrderHelpers from "../../../utils/OrderHelpers";
import LicenceItem from "./LicenceItem";

interface IProps {
  order: TApiOrderDetails;
  user: User;
}

const LicenceDetails = (props: IProps) => {
  const { order, user } = props;

  return (
    <Fragment>
      {
        order.small_business !== null &&
        <LicenceItem title="Requested Small Business Discount" value={order.small_business} />
      }

      {
        OrderPolicy.canRequestResearchLicence(user, order) &&
        <LicenceItem
          title={OrderHelpers.RESEARCH_LICENCE_LABEL_BY_VERSION_MAPPING[order.cost.version].title}
          value={order.research}
        />
      }
    </Fragment>
  )
}

export default LicenceDetails;
